'use client'

import Logo from '@/assets/logo.svg'
import LogoIconSvg from '@/assets/logo_icon.svg'
import { useAppContext } from '@/components/providers/app-provider'
import { DIGEN_SITE } from '@/config/digen'
import { Link } from '@/i18n/navigation'
import { cn } from '@/lib/utils'

interface HeaderLogoProps {
  className?: string
}

export const HeaderLogo = ({ className }: HeaderLogoProps) => {
  const { isIOS } = useAppContext()

  return (
    <Link className={cn('flex-shrink-0', className)} href={`${DIGEN_SITE}/`}>
      <div className="flex items-center gap-2">
        {/* Logo 尺寸按 Figma 设计：92x24px */}
        <Logo className="hidden h-[24px] w-[92px] md:block" />
        <LogoIconSvg className="block h-8 w-[34px] md:hidden" style={{ height: isIOS ? '32px' : '32px', width: isIOS ? '34px' : '34px' }} />
      </div>
    </Link>
  )
}

interface LogoIconProps {
  className?: string
}

export const LogoIcon = ({ className }: LogoIconProps) => {
  return (
    <Link className={cn('flex-shrink-0', className)} href={`${DIGEN_SITE}/`}>
      <div className="flex items-center gap-2">
        <LogoIconSvg className="h-7 w-6.5" />
      </div>
    </Link>
  )
}
